import { initializeApp, getApp, getApps } from 'firebase/app'
import {
  firebaseApiKey,
  firebaseAuthDomain,
  firebaseProjectId,
  firebaseStorageBucket,
  firebaseMessagingSenderId,
  firebaseAppId,
} from 'src/config'

const FIREBASE_CONFIG = {
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  projectId: firebaseProjectId,
  storageBucket: firebaseStorageBucket,
  messagingSenderId: firebaseMessagingSenderId,
  appId: firebaseAppId,
}

let app = null

export function getFirebaseApp() {
  if (app) return app
  app = getApps().length ? getApp() : initializeApp(FIREBASE_CONFIG)
  return app
}
